import FileSelectCode from "!!raw-loader!./fileSelect/FileSelect";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import FileSelect from "./fileSelect/FileSelect";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("FileSelect", FileSelectCode, FileSelect),
	];

	return (
		<Pane
			components={components}
			imports={"import {FileSelect} from \"designSystem/index\";"}
			{...props}
		/>
	);
};